//imports
import { all } from 'redux-saga/effects';

//Views
import resultsSagas from 'Modules/transactions/views/results/redux/saga';
import transactionsDetailsSagas from 'Modules/transactions/.components/transactionsDetails/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        resultsSagas(),
        transactionsDetailsSagas()
    ]);
}